<template>
  <div>
    <h1>{{ questionLabel }}</h1>

    <div class="response">
      <vv-valid v-if="responseIsValid" class="response-box">
        <green-check class="response-icon" />
        <div class="response-text">
          <div class="user-response">
            <ul>
              <li v-for="userResponse in userResponseLabels" :key="userResponse">
                {{ userResponse }}
              </li>
            </ul>
          </div>
          <p class="indicator right-response">{{ $t('quiz.rightResponse') }}</p>
        </div>
      </vv-valid>

      <vv-invalid v-else class="response-box">
        <red-cross class="response-icon" />
        <div class="response-text">
          <div class="user-response">
            <ul>
              <li v-for="userResponse in userResponseLabels" :key="userResponse">
                {{ userResponse }}
              </li>
            </ul>
          </div>
          <p class="indicator wrong-response">{{ $t('quiz.wrongResponse') }}</p>
          <p>{{ $t('quiz.rightResponseWas') }}</p>
          <div class="expected-response">
            <ul>
              <li v-for="response in validResponseLabels" :key="response">{{ response }}</li>
            </ul>
          </div>
        </div>
      </vv-invalid>
    </div>

    <div class="explanation" v-if="question.explanation">
      <vv-speech-bubble :title="$t('quiz.vinovibesExplains')">
        <vv-rich-text :document="question.explanation"></vv-rich-text>
      </vv-speech-bubble>
    </div>
  </div>
</template>

<script>
import get from 'lodash/get'

import { sameItems } from '@/services/compare'
import { VvInvalid, VvRichText, VvSpeechBubble, VvValid } from '@/components/common'
import GreenCheck from '@/components/layout/svg/GreenCheck'
import RedCross from '@/components/layout/svg/RedCross'

export default {
  name: 'MultipleResponseItem',
  components: { GreenCheck, RedCross, VvInvalid, VvRichText, VvSpeechBubble, VvValid },
  props: {
    questionId: String
  },
  computed: {
    question() {
      return this.$store.state.quiz.question.byId[this.questionId]
    },
    userResponse() {
      return get(this.$store.state.quiz, ['userResponses', 'byId', this.questionId], [])
    },
    expectedResponse() {
      return get(this.question, 'expectedResponse', [])
    },
    responseIsValid() {
      return sameItems(this.expectedResponse, this.userResponse)
    },
    questionLabel() {
      return this.question.data.question
    },
    userResponseLabels() {
      const choices = this.question.data.choices
      const userResponses = this.userResponse.choices.map(index => choices[index]).filter(Boolean)
      return userResponses.map(response => response.label)
    },
    validResponseLabels() {
      const choices = this.question.data.choices
      const validResponses = this.expectedResponse.choices.map(index => choices[index])
      return validResponses.map(response => response.label)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/response.scss';
</style>
